// extracted by mini-css-extract-plugin
module.exports = {"next":"DirectionButton_next__Pc9sg","prev":"DirectionButton_prev__uqK92","icon":"DirectionButton_icon__m6yxB","label":"DirectionButton_label__C8ql3"};